import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Currency, Percentage } from '../components';

export const ResultRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  box-sizing: border-box;
  padding: 16px 0;

  color: ${({ theme }) => theme.primaryColor};
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.5px;

  border-bottom: 1px dashed ${({ theme }) => theme.borderColor};

  &:first-of-type {
    padding-top: 0;
  }
  &:last-of-type {
    padding-bottom: 0;
    border: none;
  }


  > span {
    display: flex;
    align-items: center;

    &:before {
      content: "${({ valuePrefix }) => valuePrefix}";
      display: block;
      margin-right: 4px;
      margin-top: ${({ valuePrefix }) => valuePrefix === '+' ? '-0.1em' : '-0.25em'};
      font-size: 18px;
    }
  }

  @media ${({ theme }) => theme.mobile} {
    font-size: 12px;
  }
`;

const ResultDetail = ({ children, value, valueIsPercentage, fontWeight, ...props }) => {
  const Formatter = valueIsPercentage ? Percentage : Currency;
  return (
    <ResultRow {...props}>
      {children}
      <Formatter fontSize={'18'} fontWeight={fontWeight} value={value} />
    </ResultRow>
  );
};

ResultDetail.propTypes = {
  children: PropTypes.any.isRequired,
  value: PropTypes.number.isRequired,
  valueIsPercentage: PropTypes.bool,
  valuePrefix: PropTypes.string,
  fontWeight: PropTypes.string,
};

ResultDetail.defaultProps = {
  valueIsPercentage: false,
  valuePrefix: '',
  fontWeight: '800',
};

export default ResultDetail;
